<template>
  <div>
    <ProgressBar v-if="loading" mode="indeterminate" style="height: 0.2em" />
    <div id="designer-content"></div>
  </div>
</template>

<script setup>
import { ref, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useToast } from 'primevue/usetoast'
import { formatString } from '../utils'

const route = useRoute();
const store = useStore();
const toast = useToast();

const loading = ref(true);
const template = ref(null);
const config = store.getters.config('reportDesigner');
const COMPONENT_NAME = 'ReportDesigner';

const templateService = store.getters.nameToService(
    config.serviceName,
    store.getters.info.login,
    store.getters.password,
    config.entityName,
    config.entitySpec
  );
let designerInstance = null;

const handleError = (error, methodName) => {
  store.commit('SET_ERROR', {
    er: error?.response ?? error,
    source: [COMPONENT_NAME, methodName]
  });
}

const destroyDesigner = () => {
  if (designerInstance) {
    const container = document.getElementById('designer-content');
    if (container) container.innerHTML = '';
    designerInstance = null;
  }
}

const loadStimulsoftLicense = () => {
  if (window.Stimulsoft?.Base?.StiLicense) {
    window.Stimulsoft.Base.StiLicense.loadFromFile('license.key');
  }
}

const getDesignerOptions = () => {
  const options = new window.Stimulsoft.Designer.StiDesignerOptions();
  options.appearance.fullScreenMode = false;
  // options.toolbar.showPreviewButton = false;
  // options.toolbar.showFileMenu = false;
  // options.components.showImage = false;
  // options.components.showShape = false;
  // options.components.showPanel = false;
  // options.components.showCheckBox = false;
  // options.components.showSubReport = false;
  return options;
}

const saveReport = (data) => {
  templateService.putData(
    {
      report_template_id: template.value.report_template_id,
      report_template_data: data,
    }, config.updateSpec)
    .then(() => {
      toast.add({
        severity: 'success',
        summary: 'Дизайн сохранён',
        detail: 'Конфигурация отчёта обновлена',
        life: 3000,
      });
    })
    .catch((er) => handleError(er, 'saveReport'));
}

const showReport = () => {
  if (!template.value || !window.Stimulsoft) return;

  destroyDesigner();
  loadStimulsoftLicense();

  const options = getDesignerOptions();
  const designer = new window.Stimulsoft.Designer.StiDesigner(options, 'StiDesigner', false);

  designer.onSaveReport = (e) => {
    let jsonStr = e.report.saveToJsonString();
    const jsonObj = JSON.parse(jsonStr);
    jsonObj.ReportFile = `${template.value.report_template_name}.mrt`;
    jsonObj.ReportAlias = template.value.report_name;
    jsonObj.ReportName = template.value.report_template_sysname;
    jsonStr = JSON.stringify(jsonObj);
    saveReport(jsonStr);
  }

  const report = new window.Stimulsoft.Report.StiReport();
  report.load(template.value.report_template_data);

  const connectionString = formatString(
    store.getters.connectionPath,
    store.getters.info.login,
    store.getters.password
  );
  for (const db of report.dictionary.databases.list) {
    db.connectionString = connectionString;
  }

  designer.report = report;
  designer.renderHtml('designer-content');
  designerInstance = designer;
}

const prepareTemplate = () => {
  const templateId = route.params.id;
  if (!templateId) return;

  loading.value = true;
  /*templateService = store.getters.nameToService(
    config.serviceName,
    store.getters.info.login,
    store.getters.password,
    config.entityName,
    config.entitySpec
  );*/

  templateService
    .getData({ report_template_id: templateId })
    .then((data) => {
      if (data && data.length) {
        template.value = data[0];
        showReport();
      }
    })
    .catch((er) => handleError(er, 'prepareTemplate'))
    .finally(() => loading.value = false);
}

watch(
  () => ({ id: route.params.id, name: route.name }),
  (newVal, oldVal) => {
    if (newVal.name === 'report-designer' && newVal.id !== oldVal?.id) {
      prepareTemplate();
    }
  },
  { immediate: true }
)


onUnmounted(() => {
  destroyDesigner();
})
</script> 